module.exports = __webpack_public_path__ + "media/images/logo/logo-medicina-x-b875545cd4058cf1a886582babd2e23e.svg";